import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { GemToastComponent } from '@dpod/gem-ui-common-ng/toast';
import { environment } from '@env/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AppComponent } from './app.component';
import { InMemoryBackend } from './clients/in-memory-db.service';
import { ShellModule } from './shell/shell.module';
import { MetricsModule, HeapBackendProvider } from '@dpod/gem-ui-common-ng';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    (environment.isMock
      ? InMemoryWebApiModule.forRoot(InMemoryBackend, { delay: 750 })
      : []
    ),
    TranslateModule.forRoot(),
    MetricsModule.forBackends([ HeapBackendProvider ]),
    NgbModule,
    CoreModule,
    SharedModule,
    ShellModule,
    AppRoutingModule,
  ],
  declarations: [AppComponent],
  providers: [Title],
  bootstrap: [AppComponent],
  entryComponents: [GemToastComponent]
})
export class AppModule { }
